// extracted by mini-css-extract-plugin
export var cardContainer = "_na-0";
export var cardHeader = "_na-2";
export var collapsedState = "_na-3";
export var dragHandle = "_na-5";
export var dragHandleIcon = "_na-6";
export var dragging = "_na-1";
export var titleArea = "_na-4";